export default __webpack_public_path__ + "static/media/suggested-vat-account-5-5.14c21ceb.png";